import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fileUrl = (p) => (p ? (String(p).startsWith("http") ? p : `${BACKEND_URL}${p}`) : null);

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Surface a friendly toast whenever the backend rate-limits a request (HTTP 429)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 429) {
      const detail = formatApiErrorDetail(error.response.data?.detail);
      toast.error("Hold on a moment", {
        id: "rate-limit",
        description:
          detail ||
          "You've hit the hourly limit for this action. Please wait a little while and try again.",
      });
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
